{
    "autocomplete": {
        "no_suggestions": "No suggestions available"
    },
    "context_menu": {
        "copy": "Copy",
        "cut": "Cut",
        "delete": "Delete",
        "marker": {
            "navigation": "Go to",
            "next": "Next marker",
            "previous": "Previous marker"
        },
        "paste": "Paste"
    },
    "diagram": {
        "label": "Diagram"
    },
    "focus": {
        "focus_not_set": "Focus not set",
        "focus_off": "Currently no element is focused.",
        "focus_on": "Currently focused: ",
        "focus_within": "Within",
        "shortcut_focus_graph": "Focus on graph",
        "shortcut_focus_palette": "Focus on tool palette"
    },
    "grid": {
        "shortcut_zoom_in": "Zoom in via grid",
        "zoom_in_grid": "Select a digit from 1-9 to zoom in on the respective box."
    },
    "issue_marker": {
        "severity_error": "ERROR",
        "severity_info": "INFO",
        "severity_warning": "WARNING"
    },
    "move": {
        "shortcut_move": "Move element"
    },
    "navigation": {
        "default_navigation_mode_activated": "Navigation On: Use arrow keys to select preceding (←) or succeding (→) elements. Use the up (↑) and down (↓) arrows to navigate paths. Press 'N' to exit.",
        "default_navigation_mode_deactivated": "Navigation Off: Press 'N' for default navigation, 'ALT+N' for position based navigation.",
        "local_navigation_mode_activated": "Position based Nav On: Navigate nearest elements using arrow keys: (↑) for above, (↓) for below, (←) for previous, (→) for next element. Press 'ALT+N' to exit.",
        "local_navigation_mode_deactivated": "Position based Nav Off: Press 'N' for default navigation, 'ALT+N' for position based navigation.",
        "shortcut_global_mode": "Activate global navigation mode",
        "shortcut_local_mode": "Activate local navigation mode"
    },
    "resize": {
        "resize_mode_activated": "Resize On: Use plus(+) and minus(-) to resize, 'CTRL'+'0' for default size. Press 'ESC' to exit.",
        "resize_mode_deactivated": "Resize Off: Press 'ALT'+'A' for resize mode.",
        "shortcut_activate": "Activate resize mode for selected element",
        "shortcut_deactivate": "Deactivate resize handler",
        "shortcut_decrease": "Decrease size of element",
        "shortcut_increase": "Increase size of element",
        "shortcut_reset": "Set element size to default"
    },
    "search": {
        "label": "Search Field",
        "placeholder": "Search for elements...",
        "shortcut_activate": "Activate search for elements"
    },
    "shortcut": {
        "group_focus": "Focus",
        "group_graph": "Graph",
        "group_grid": "Grid",
        "group_move": "Move",
        "group_navigation": "Navigation",
        "group_resize": "Resize",
        "group_search": "Search",
        "group_tool_palette": "Tool Palette",
        "group_viewport": "Viewport",
        "group_zoom": "Zoom",
        "header_command": "Command",
        "header_shortcut": "Keybinding",
        "menu_title": "Shortcut Menu",
        "title": "Keyboard Shortcuts"
    },
    "tool_palette": {
        "debug_mode_button": "Debug Mode",
        "delete_button": "Enable deletion tool",
        "label": "Tool Palette",
        "marquee_button": "Enable marquee tool",
        "marquee_message": "Currently marquee tool is only usable with mouse.",
        "maximize": "Maximize palette",
        "minimize": "Minimize palette",
        "no_items": "No results found.",
        "reset_viewport_button": "Reset Viewport",
        "search_button": "Filter palette entries",
        "search_placeholder": "Search...",
        "selection_button": "Enable selection tool",
        "toggle_grid_button": "Toggle Grid",
        "validate_button": "Validate model"
    },
    "viewport": {
        "shortcut_move_viewport": "Move viewport",
        "shortcut_zoom_element": "Zoom element",
        "shortcut_zoom_viewport": "Zoom viewport"
    }
}
